<template>
  <v-content>
    <v-layout wrap row>
      <v-flex md12>
        <ContactForm formType="register"></ContactForm>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import Vue from 'vue'
import ContactForm from './widgets/ContactForm'

export default {
  name: 'Register',
  components: {ContactForm},
  methods: {
    open: function () {
    }
  },
  data () {
    return {}
  },
  mounted () {
    Vue.prototype.$eventHub.$emit('OnShowLogin', true)
    Vue.prototype.$eventHub.$emit('OnShowRegister', true)
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Register.vue